export const fetchFacilities = () => {
  return fetch(`${process.env.REACT_APP_API}/api/facilities`)
    .then((res) => res.json())
    .then((res) => {
      return res.data;
    });
};

export const fetchPointOfInterests = (lat, lng, radius) => {
  return fetch(`${process.env.REACT_APP_API}/api/point-of-interests`)
    .then((res) => res.json())
    .then((res) => {
      return res.data;
    });
};

export const fetchProjects = (lat, lng, radius) => {};

export const uploadRoomsCsv = (formData) => {
  return fetch(`${process.env.REACT_APP_API}/api/upload-rooms-csv`, {
    method: "POST",
    body: formData,
  })
    .then((res) => res.json())
    .then((res) => {
      return res.status;
    });
};

export const importUploadedRooms = () => {
  return fetch(`${process.env.REACT_APP_API}/api/import-uploaded-rooms`)
    .then((res) => res.json())
    .then((res) => {
      return res.status;
    });
};

export const importUploadedRoomsFromFirebase = (path) => {
  // console.log("url??", url);
  return fetch(
    `${process.env.REACT_APP_API}/api/import-uploaded-rooms-from-firebase?path=${path}`
  )
    .then((res) => res.json())
    .then((res) => {
      return res.status;
    });
};

export const importUploadedProjectsFromFirebase = (path) => {
  // console.log("url??", url);
  return fetch(
    `${process.env.REACT_APP_API}/api/import-uploaded-projects-from-firebase?path=${path}`
  )
    .then((res) => res.json())
    .then((res) => {
      return res.status;
    });
};



// WEBPACK FOOTER //
// ./src/api/index.js